import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgInspectionItemFile } from '../models/reports/jg-inspection-item-file.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionJgItemFileService extends RequestService<JgInspectionItemFile> {
  static PATH = '/inspection/jg/item/file';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, InspectionJgItemFileService.PATH, globalService.debugUrl);
  }
}
